import { useState, useEffect } from 'react';
import { ASSETS } from '@/constants/assets';

const NAV_ITEMS = [
  { label: 'Serviços', href: '#servicos' },
  { label: 'Equipamentos', href: '#equipamentos' },
  { label: 'Marcas', href: '#marcas' },
  { label: 'Processo', href: '#processo' },
  { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'Contato', href: '#contato' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = () => setMobileOpen(false);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70 shadow-[0_1px_3px_rgba(0,0,0,0.04)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-container mx-auto px-4 md:px-6">
        <div className="flex items-center h-[120px] md:h-[176px]">

          {/* Logo — transparente, flutua sobre o Hero */}
          <div className="flex-shrink-0 mr-10 lg:mr-12">
            <a
              href="#"
              className="inline-flex transition-all duration-300"
              aria-label="DURAFLOW - Voltar ao topo"
            >
              <img
                src={ASSETS.logos.duraflowHeader}
                alt="DURAFLOW Soluções Hidráulicas"
                className="h-[82px] md:h-[125px] w-auto"
              />
            </a>
          </div>

          {/* Nav — desktop, centered in remaining space */}
          <nav
            className="hidden md:flex flex-1 items-center justify-center gap-7 lg:gap-9"
            aria-label="Navegação principal"
          >
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`relative text-sm font-medium whitespace-nowrap cursor-pointer py-1 transition-colors duration-300 group ${
                  scrolled
                    ? 'text-foreground-900 hover:text-primary-500'
                    : 'text-background-50/90 hover:text-primary-400'
                }`}
              >
                {item.label}
                <span
                  className={`absolute -bottom-0.5 left-0 w-0 h-px transition-all duration-300 group-hover:w-full ${
                    scrolled ? 'bg-primary-500' : 'bg-primary-400'
                  }`}
                ></span>
              </a>
            ))}
          </nav>

          {/* Mobile hamburger */}
          <div className="flex md:hidden flex-1 justify-end">
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className={`w-10 h-10 flex items-center justify-center cursor-pointer transition-colors duration-300 ${
                scrolled ? 'text-foreground-800' : 'text-background-50'
              }`}
              aria-label={mobileOpen ? 'Fechar menu' : 'Abrir menu'}
              aria-expanded={mobileOpen}
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>

        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <nav
            className="max-w-container mx-auto px-4 py-4 flex flex-col gap-1"
            aria-label="Menu mobile"
          >
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={handleNavClick}
                className="block py-3 px-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors duration-200"
              >
                {item.label}
              </a>
            ))}
            <div className="flex flex-col gap-2 mt-3 pt-3 border-t border-background-200/70">
              <a
                href={ASSETS.social.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 py-3 px-3 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 rounded-md cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg w-5 h-5 flex items-center justify-center"></i>
                WhatsApp
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}